document.addEventListener('DOMContentLoaded', () => {

  const ProductsFabric = document.querySelectorAll('[product-fabric]');
  if(Boolean(ProductsFabric)){
    ProductsFabric.forEach((ProductFabric)=>{

      const slider = ProductFabric.querySelector('[product-slider]');
      let slider_swiper;

      if(Boolean(slider)){
        const slider_count_slides = slider.dataset.countSlides;

        if(slider_count_slides > 1){
            slider_swiper = new Swiper(slider, {
              loop: true,
              pagination: {
                el: slider.querySelector('.swiper-pagination'),
                type: "fraction",
              },
              navigation: {
                nextEl: slider.querySelector('[product-slider-btn-next]'),
                prevEl: slider.querySelector('[product-slider-btn-prev]'),
              }
            });
          }
      }

      const ButtonReservPopupOpen = ProductFabric.querySelector('[product-reservinfo-popup-btn-open]');
      const ButtonReservPopup = ProductFabric.querySelector('[product-reservinfo-popup]');
      const ButtonReservClose = ButtonReservPopup.querySelector('[product-reservinfo-popup-close]');
      const ButtonReservOverlow = ButtonReservPopup.querySelector('.ProductInfoReservPopupOverflow');
      const ButtonReservButton = ButtonReservPopup.querySelector('.ProductInfoReservPopupContentButton');
      
      if(Boolean(ButtonReservPopupOpen)){
        ButtonReservPopupOpen.addEventListener('click', ()=>{
          ButtonReservPopup.style.display = 'block'
        })
      }

      if(Boolean(ButtonReservClose)){
        ButtonReservClose.addEventListener('click', ()=>{
          ButtonReservPopup.style.display = 'none'
        })
      }

      if(Boolean(ButtonReservOverlow)){
        ButtonReservOverlow.addEventListener('click', ()=>{
          ButtonReservPopup.style.display = 'none'
        })
      }

      if(Boolean(ButtonReservButton)){
        ButtonReservButton.addEventListener('click', ()=>{
          ButtonReservPopup.style.display = 'none'
        })
      }
      

      
      
    })
    
  }

  

  
})